import {
    AnonymityType,
    FormatType,
    ProcessedManagerTemplate,
    Template,
    TemplateType,
} from 'src/models/employerMailTemplates';
import { FullStage, Template as ChangeTopicTemplate } from 'src/models/employerNegotiationsChangeTopic';

const isValidTemplate = (template: Template, type: TemplateType | null): boolean => {
    // При запросе темплейтов с AnonymityType.COMMON, бэк также возвращает шаблоны с типом NONE,
    // а их нужно исключить
    if (template.anonymityType === AnonymityType.NONE) {
        return false;
    }
    // для некоторых employerState у нас есть шаблоны нескольких типов(type)
    // нам нужно убедиться, что выбираем нужный тип, исходя из данных воронки
    return template.type === type;
};

// Утилита подготавливает шаблоны для текстов и смс

export const processOwnersTemplates = (
    templates: Template[],
    employerManagerTemplateId: number | null,
    smsEmployerManagerTemplateId: number | null,
    templateType: TemplateType | null,
    smsTemplateType: TemplateType | null,
    useAnonymousTemplate: boolean
): { mailTemplates: ProcessedManagerTemplate[] | []; smsTemplates: ProcessedManagerTemplate[] | [] } => {
    const result = templates.reduce(
        (acc: [ProcessedManagerTemplate[], ProcessedManagerTemplate[]], template) => {
            const processedTemplate = { ...template, isSelected: false };
            const isPrimaryTemplate = !!template.primaryTemplate;

            if (template.formatType === FormatType.MAIL && isValidTemplate(template, templateType)) {
                acc[0].push({
                    ...processedTemplate,
                    isSelected:
                        (!useAnonymousTemplate && template.id === employerManagerTemplateId) ||
                        ((useAnonymousTemplate || !employerManagerTemplateId) && isPrimaryTemplate),
                });
            }
            if (template.formatType === FormatType.SMS && isValidTemplate(template, smsTemplateType)) {
                acc[1].push({
                    ...processedTemplate,
                    isSelected:
                        (!useAnonymousTemplate && template.id === smsEmployerManagerTemplateId) ||
                        ((useAnonymousTemplate || !smsEmployerManagerTemplateId) && isPrimaryTemplate),
                });
            }

            return acc;
        },
        [[] as ProcessedManagerTemplate[], [] as ProcessedManagerTemplate[]]
    );
    return { mailTemplates: result[0], smsTemplates: result[1] };
};

export const processGuestsTemplates = (
    templates: Template[],
    templateType: TemplateType | null,
    smsTemplateType: TemplateType | null
): { mailTemplates: ProcessedManagerTemplate[] | []; smsTemplates: ProcessedManagerTemplate[] | [] } => {
    const result = templates.reduce(
        (acc: [ProcessedManagerTemplate[], ProcessedManagerTemplate[]], template) => {
            const processedTemplate = { ...template, isSelected: false };

            if (template.formatType === FormatType.MAIL && isValidTemplate(template, templateType)) {
                acc[0].push(processedTemplate);
            }
            if (template.formatType === FormatType.SMS && isValidTemplate(template, smsTemplateType)) {
                acc[1].push(processedTemplate);
            }
            return acc;
        },
        [[] as ProcessedManagerTemplate[], [] as ProcessedManagerTemplate[]]
    );
    return { mailTemplates: result[0], smsTemplates: result[1] };
};

const replaceTemplateParams = (templates: Template[], templateParams: Record<string, string>): Template[] => {
    return templates.map((templateObject) => {
        Object.entries(templateParams).forEach(([key, value]) => {
            if (templateObject.template?.includes(key)) {
                templateObject.template = templateObject.template.replaceAll(`[${key}]`, value);
            }
        });
        return templateObject;
    });
};

export const updateTemplatesParams = (
    templates: { ownersTemplates: Template[]; currentEmployerTemplates: Template[] },
    templateParams: Record<string, string>
): { ownersTemplates: Template[]; currentEmployerTemplates: Template[] } => {
    const { ownersTemplates, currentEmployerTemplates } = templates;
    return {
        ownersTemplates: replaceTemplateParams(ownersTemplates, templateParams),
        currentEmployerTemplates: replaceTemplateParams(currentEmployerTemplates, templateParams),
    };
};

export const getTemplateData = (
    ownersTemplates: ProcessedManagerTemplate[],
    guestTemplates: ProcessedManagerTemplate[]
) => {
    return guestTemplates.length
        ? {
              text: guestTemplates.find((template) => template.primaryTemplate)?.template || '',
              id: guestTemplates.find((template) => template.primaryTemplate)?.id,
          }
        : {
              text: ownersTemplates.find((template) => template.isSelected)?.template || '',
              id: ownersTemplates.find((template) => template.isSelected)?.id,
          };
};

export const getChangeTopicTemplatesTextAndId = (
    changeTopicTemplatesData: ChangeTopicTemplate[],
    isChangeTopicWithFunnel: boolean,
    stage: FullStage | undefined
) => {
    let mailText = changeTopicTemplatesData.find((item) => item.type === 'mail')?.content || '';
    let mailTextId: number | null | undefined;
    let smsText = changeTopicTemplatesData.find((item) => item?.type === 'sms')?.content || '';
    let smsTextId: number | null | undefined;

    if (isChangeTopicWithFunnel && stage) {
        mailText = stage.templateInfo.template || '';
        mailTextId = stage.templateInfo.employerManagerTemplateId;

        smsText = stage.templateInfo.smsTemplate || '';
        smsTextId = stage.templateInfo.smsEmployerManagerTemplateId;
    }

    return { mailText, mailTextId, smsText, smsTextId };
};
